import WordPressContent from '../components/WordpressContent';
import { withWPData } from '../components/withWPData';


export default withWPData(386)(WordPressContent);
